var exports = {
  "Pf": "MyProfileTabUsernameSection.module__label___RklmVE",
  "o1": "MyProfileTabUsernameSection.module__actions___RklmVE",
  "Sn": "MyProfileTabUsernameSection.module__premiumButton___RklmVE",
};

module.exports = exports;
